import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password } from '../internal.js'

const credentialTypes = [password, 'user-id', 'email'] as const

export type vityCredType = (typeof credentialTypes)[number]

export const vityDocumentTypes = [
  'proof-of-delivery',
] as const satisfies readonly DocumentType[]

export const vity: CarrierDef<vityCredType> = {
  name: 'Vitran Express',
  scac: 'vity',
  credentialTypes,
  legacyCredMap: [
    ['user-id', 'username'],
    ['password', 'password'],
    ['email', 'email'],
  ],
  engineLayers: ['documents'],
  documentTypes: vityDocumentTypes,
}
